export default import.meta.ROLLDOWN_FILE_URL_0tfJ1IATSKuUy5GMnGNo6w